import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import AdminLayout from "../../layout/AdminLayout";
import { useAuth } from "../../../context/AuthContext";
import * as model from "../../../models/ResumeParserModel";
import { useNotificationCount } from "../../../context/NotificationCountContext";
import ResumesTable from "./ResumesTable";
import { ConfirmDelete } from "../../modals/ConfirmDelete";
import { apiError } from "../../../helpers/ErrorHelper";
import { toast } from "react-toastify";
import PageHeader from "../../common/PageHeader";
import config from "../../../config/config";
import { MyReactSelect, MyReactSelectMultiple } from "../../inputs/inputs";
import { ResumesForm } from "./ResumesForm";
import { checkPermission } from "../../../helpers/GeneralHelper";
import SendResumesModal from "../../modals/SendResumesModal";
import CreateCandidateFromResumeModal from "../../modals/CreateCandidateFromResumeModal";
import BulkCreateCandidatesFromResumeModal from "../../modals/BulkCreateCandidatesFromResumeModal";
import { getData as getClients } from '../../../models/ClientsModel';
import { getData as getRequirements } from '../../../models/RequirementsModel';
import { getData as getSkills } from '../../../models/SkillsModel';
import {
  buildCandidateCreateStateFromResume,
  CANDIDATE_MODULE,
  findDuplicateCandidates,
  formatDuplicateCandidateLabel,
  getResumeConversionInfo,
  isResumeConverted,
} from "../../../helpers/ResumeToCandidateHelper";
import { getSingleData as getCandidateByUniqueId } from "../../../models/CandidatesModel";
//import { RequirementView } from "./RequirementView";

export default function Resumes() {
    const module = {
        title: 'Resumes',
        singularTitle: 'Resume',
        key: 'resume_uploads',
        route: 'resumes',
        primaryCol: '_resume_id'
    };

    const { state } = useAuth();
    let user_data = state.user_data;
    const [searchParams] = useSearchParams();

    const navigate = useNavigate();
    //const [candidateStatuses, setCandidateStatuses] = useState([]);
    const [isTrash, setIsTrash] = useState(false);

    const [listData, setListData] = useState([]);
    const [cacheTime, setCacheTime] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [toggleAddModal, setToggleAddModal] = useState(false);
    const [selectedResumes, setSelectedResumes] = useState([]);
    const [showSendModal, setShowSendModal] = useState(false);
    const [showCreateCandidateModal, setShowCreateCandidateModal] = useState(false);
    const [showBulkCreateCandidateModal, setShowBulkCreateCandidateModal] = useState(false);
    const [resumeForCandidate, setResumeForCandidate] = useState(null);
    const [creatingCandidate, setCreatingCandidate] = useState(false);
    const [skills, setSkills] = useState([]);
    const [clients, setClient] = useState([]);
    const [requirements, setRequirement] = useState([]);
    const [allRequirements, setAllRequirements] = useState([]);

    const fetchData = async (newLimit, page) => {
        setLoading(true);

        try {
            let apiParam = {
                search: searchQuery,
                page: page,
                limit: newLimit,
                user_token: user_data.user_token,
            };
            const response = await model.getData(apiParam);
            if (typeof response == typeof undefined) {
                navigate("/re-login");
                return;
            }

            setListData(response[module.key]);
            setTotalRows(response.pagination.total_rows);
            setLimit(newLimit);
            setPage(page);
            //setCandidateStatuses(response.candidate_status_list || []);

            if (response.time) {
                setCacheTime(response.time);
            }

            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    };
    // Flush Start
    const flashData = async () => {
        localStorage.removeItem(module.key);
        fetchData(limit, page);
    };
    // Flush End
    useEffect(() => {
        fetchData(limit, page);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fetchClients = async () => {
        try {
            const result = await getClients({user_token: user_data.user_token, page: 1, limit: -1});//, candidate_id:candidate_id
            if (! result) return;
        
            const clientOptions = result.clients.map(client => ({
                value: client._client_id,
                label: client.client_name
            }));
            setClient(clientOptions);
            
        } catch (error) {
            console.error(error);
        }
    };
    const [loadingRequirements, setLoadingRequirements] = useState(false);
    const fetchRequirements = async () => {
        setLoadingRequirements(true);
        try {
            const apiParam = {
                user_token: user_data.user_token,
                page: 1,
                limit: -1
            };
    
            const response = await getRequirements(apiParam);
            if (response?.requirements) {
                const options = response.requirements.map(item => ({
                    value: item._requirement_id,
                    label: item.requirement_name,
                    client_id: item.requirement_client_id, // needed for local filter
                }));
        
                setRequirement(options);
                setAllRequirements(options);
            }
        } catch (error) {
            console.error(error);
        }
        setLoadingRequirements(false);
    };
    useEffect(() => {
        fetchClients();
        fetchRequirements();
        const fetchSkills = async () => {
            try {
                const response = await getSkills({
                    user_token: user_data.user_token,
                    page: 1,
                    limit: -1,
                });
                if (response?.skills) {
                    setSkills(
                        response.skills.map((row) => ({
                            value: row._skill_id,
                            label: row.skill_name,
                        }))
                    );
                }
            } catch (error) {
                console.error(error);
            }
        };
        fetchSkills();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleSendResumes = async (data) => {
        // data = { resumes: [...], client: "X", requirement: "Y" }
        console.log("🚀 Sending resumes payload:", data);

        // TODO: Call backend API
        // await model.sendResumes(data);
        const response = await model.sendResume(user_data.user_token, data);
        if (typeof response == typeof undefined) {
            navigate("/re-login");
            return;
        }
        //toast.success("Resumes sent successfully!");
    };

    const openCreateCandidateModal = (resume) => {
        if (isResumeConverted(resume)) {
            handleViewConvertedCandidate(resume);
            return;
        }
        setResumeForCandidate(resume);
        setShowCreateCandidateModal(true);
    };

    const handleViewConvertedCandidate = async (resume) => {
        const conversion = getResumeConversionInfo(resume);
        if (!conversion?.candidateUniqueId) {
            toast.error("Could not open linked candidate.");
            return;
        }

        try {
            const response = await getCandidateByUniqueId({
                user_token: user_data.user_token,
                id: conversion.candidateUniqueId,
            });

            if (!response?.candidate) {
                toast.error("Linked candidate was not found.");
                return;
            }

            navigate(`/candidates/${conversion.candidateUniqueId}/view`, {
                state: {
                    module: CANDIDATE_MODULE,
                    data: response.candidate,
                },
            });
        } catch (error) {
            console.error(error);
            toast.error("Could not open linked candidate.");
        }
    };

    const handleCreateCandidate = async ({
        clientId,
        clientName,
        requirementId,
        requirementName,
    }) => {
        if (!resumeForCandidate) return;

        if (isResumeConverted(resumeForCandidate)) {
            toast.warning("This resume has already been converted to a candidate.");
            setShowCreateCandidateModal(false);
            setResumeForCandidate(null);
            handleViewConvertedCandidate(resumeForCandidate);
            return;
        }

        setCreatingCandidate(true);
        try {
            const duplicates = await findDuplicateCandidates(user_data.user_token, {
                email: resumeForCandidate.resume_email,
                mobile: resumeForCandidate.resume_phone,
            });

            if (duplicates.length > 0) {
                toast.warning(
                    `Possible duplicate candidate: ${formatDuplicateCandidateLabel(duplicates[0])}. Review before saving.`
                );
            }

            const createState = buildCandidateCreateStateFromResume(
                resumeForCandidate,
                { clientId, clientName, requirementId, requirementName },
                skills
            );

            if (!createState) {
                toast.error("Could not build candidate prefill from this resume.");
                return;
            }

            setShowCreateCandidateModal(false);
            setResumeForCandidate(null);
            navigate("/candidates/create", { state: createState });
        } catch (error) {
            console.error(error);
            toast.error("Could not open candidate form.");
        } finally {
            setCreatingCandidate(false);
        }
    };

    return (
        <AdminLayout>
            <Helmet>
                <title>{module.title} - Digital CMS</title>
            </Helmet>
            <div className="main-content app-content">
                <div className="container-fluid">
                    <PageHeader module={module} isTrash={isTrash}  />
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card custom-card">
                            {/* {listData.length > 0 && (
                                <div className="col-xl-6 mt-4 mx-2">
                                    <button className="btn btn-primary ms-3" onClick={exportToExcel}>Download Excel</button>
                                </div>
                            )} */}
            {! isTrash &&       <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
                                    <div className="card-title">{ config.isCache ? `Last Synced On ${cacheTime}` : module.title }</div>

                                    <div className="d-flex align-items-center gap-2 flex-wrap">
                                        {/* Search Box */}
                                        <div className="d-flex align-items-center" style={{ flex: "0 0 auto" }}>
                                            <div className="input-group" style={{ width: "300px" }}>
                                                <input type="text" className="form-control" placeholder='Search (e.g. "react NOT java")' value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                                                <button className="btn btn-primary" type="button" onClick={() => fetchData(limit, 1)}>Search </button>
                                            </div>
                                        </div>
                                    {/* Upload Button */}
                                    {checkPermission(module.route, "add") && (
                                        <button className="btn btn-primary btn-md" onClick={() => setToggleAddModal(true)}>
                                            <i className="ri-add-line me-1 fw-semibold align-middle"></i> Upload Resumes
                                        </button>
                                    )}

                                    {checkPermission("candidates", "add") && selectedResumes.length > 0 && (
                                        <button
                                            className="btn btn-success btn-md"
                                            onClick={() => setShowBulkCreateCandidateModal(true)}
                                        >
                                            <i className="ri-user-add-line me-1 fw-semibold align-middle"></i>
                                            Convert selected ({selectedResumes.length})
                                        </button>
                                    )}
                                    {/* Refresh Button */}
                                    {config.isCache && (
                                        <button className="btn btn-success-light btn-sm" onClick={() => flashData()} >
                                            <i className="ri-refresh-line me-1 fw-semibold align-middle"></i> Refresh
                                        </button>
                                    )}
                                    {/* {selectedResumes.length > 0 && (
                                        <button className="btn btn-success btn-md" disabled={selectedResumes.length === 0} onClick={() => setShowSendModal(true)} >
                                            <i className="ri-send-plane-fill me-1 fw-semibold align-middle"></i>
                                            Send Selected
                                        </button>
                                    )} */}
                                    </div>
                                </div>
            }
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <ResumesTable
                                            module={module}
                                            data={listData}
                                            loading={loading}
                                            totalRows={totalRows}
                                            fetchData={fetchData}
                                            isTrash={isTrash}
                                            limit={limit}
                                            page={page}
                                            onRowSelect={setSelectedResumes}
                                            onCreateCandidate={openCreateCandidateModal}
                                            onViewConvertedCandidate={handleViewConvertedCandidate}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ResumesForm
                        module={module}
                        showModal={toggleAddModal}
                        setShowModal={setToggleAddModal}
                        fetchData={fetchData}
                        limit={limit}
                        page={page}
                    />
                    <SendResumesModal
                    show={showSendModal}
                    onClose={() => setShowSendModal(false)}
                    selectedResumes={selectedResumes}
                    clients={clients}
                    requirements={requirements}
                    loadingRequirements={loadingRequirements}
                    onSend={handleSendResumes}
                    />
                    <CreateCandidateFromResumeModal
                        show={showCreateCandidateModal}
                        onClose={() => {
                            if (creatingCandidate) return;
                            setShowCreateCandidateModal(false);
                            setResumeForCandidate(null);
                        }}
                        resume={resumeForCandidate}
                        clients={clients}
                        onConfirm={handleCreateCandidate}
                        submitting={creatingCandidate}
                    />
                    <BulkCreateCandidatesFromResumeModal
                        show={showBulkCreateCandidateModal}
                        onClose={() => setShowBulkCreateCandidateModal(false)}
                        resumes={selectedResumes}
                        clients={clients}
                        onComplete={() => {
                            setSelectedResumes([]);
                            fetchData(limit, page);
                        }}
                    />
                </div>
            </div>
            <Helmet></Helmet>
        </AdminLayout>
    );
}